import { render, staticRenderFns } from "./RsaHomeConsegneComponent.vue?vue&type=template&id=837e0590"
import script from "./RsaHomeConsegneComponent.vue?vue&type=script&lang=js"
export * from "./RsaHomeConsegneComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaHomeConsegneComponent.vue?vue&type=style&index=0&id=837e0590&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports